// Timer mechanic (SC-H3, design §3). Counts down duration_seconds per set; sets>1 runs per set
// with dots + a between-set nudge. TIMESTAMP-BASED: remaining is computed from wall-clock deltas
// (startTs + prevMs), never a decrement, and re-painted on visibilitychange — a backgrounded tab
// shows the right time on return and never completes early/late.

const T = (k, p) => window.HUD?.T?.(k, p) || k;
const _pad = n => String(n).padStart(2, '0');
const fmt = s => Math.floor(s / 60) + ':' + _pad(s % 60);
const CIRC = 552.9; // 2π·88

export const timer = {
  key: 'timer',
  matches: e => !!e.duration_seconds,
  render(host, e, ctx) {
    const D = e.duration_seconds, sets = e.sets || 1, tint = ctx.tint || 'mint';
    let setIdx = 0, running = false, startTs = 0, prevMs = 0, iv = null, finished = false;

    host.innerHTML =
      `<div class="hwp-ring t-${tint}"><svg viewBox="0 0 196 196" width="196" height="196">` +
      `<circle class="c" cx="98" cy="98" r="88"/><circle class="p" cx="98" cy="98" r="88" stroke-dasharray="${CIRC}" stroke-dashoffset="0"/></svg>` +
      `<div class="in"><div class="t">${fmt(D)}</div><div class="l">${T('hw5_tap_start')}</div></div></div>` +
      (sets > 1
        ? `<div class="hwp-setdots">${Array.from({ length: sets }, (_, i) => `<i class="${i === 0 ? 'cur' : ''}"></i>`).join('')}</div><div class="hwp-sublabel">${T('hw5_round_k_of_n', { k: 1, n: sets })}</div>`
        : `<div class="hwp-sublabel">${T('hw5_keep_going')}</div>`);

    const ring = host.querySelector('.hwp-ring');
    const ringT = host.querySelector('.hwp-ring .t');
    const ringL = host.querySelector('.hwp-ring .l');
    const ringP = host.querySelector('.hwp-ring .p');
    const dots = host.querySelector('.hwp-setdots');
    const sub = host.querySelector('.hwp-sublabel');

    const remaining = () => Math.max(0, D - Math.floor((prevMs + (running ? Date.now() - startTs : 0)) / 1000));

    const paint = () => {
      const rem = remaining();
      ringT.textContent = fmt(rem);
      ringP.style.strokeDashoffset = String(CIRC * (1 - rem / D));
      if (rem <= 0 && running) completeSet();
    };
    const startTick = () => { if (iv) clearInterval(iv); iv = setInterval(paint, 200); };
    const stopTick = () => { if (iv) { clearInterval(iv); iv = null; } };

    function completeSet() {
      running = false; stopTick(); prevMs = 0;
      ring.classList.remove('run');
      ringT.textContent = '0:00'; ringP.style.strokeDashoffset = String(CIRC);
      setIdx++;
      if (dots && dots.children[setIdx - 1]) { dots.children[setIdx - 1].classList.add('on'); dots.children[setIdx - 1].classList.remove('cur'); }
      if (setIdx >= sets) { finished = true; setTimeout(() => ctx.onFinish({ actual_seconds: D * sets }), 300); return; }
      if (dots && dots.children[setIdx]) dots.children[setIdx].classList.add('cur');
      if (sub) sub.textContent = T('hw5_round_k_of_n', { k: setIdx + 1, n: sets });
      ringL.textContent = T('hw5_tap_start');
      ctx.toast && ctx.toast(T('hw5_next_round'));
      setTimeout(() => { if (!running && !finished) { ringT.textContent = fmt(D); ringP.style.strokeDashoffset = '0'; } }, 400);
    }

    ring.onclick = () => {
      if (finished) return;
      if (running) {
        prevMs += Date.now() - startTs; running = false; stopTick();
        ring.classList.remove('run'); ringL.textContent = T('hw5_paused');
      } else {
        startTs = Date.now(); running = true; startTick();
        ring.classList.add('run'); ringL.textContent = T('hw5_tap_pause');
      }
    };

    const onVis = () => { if (running) paint(); };
    document.addEventListener('visibilitychange', onVis);

    return {
      stop() { running = false; stopTick(); document.removeEventListener('visibilitychange', onVis); },
    };
  },
  summary(res) { return res && res.actual_seconds ? fmt(res.actual_seconds) : ''; },
};
